import {
  IDLE_LOCK_MINUTES_MAX,
  IDLE_LOCK_MINUTES_MIN,
  IDLE_LOGOUT_MINUTES_MAX,
  IDLE_LOGOUT_MINUTES_MIN,
} from '@/hooks/useTenantSettings';

export type IdleTimeoutFieldError = 'lockRange' | 'logoutRange' | 'logoutMustExceedLock';

/** Client-side pair check matching staff-api `tenantSecuritySettingsSchema`. */
export function validateIdleTimeoutPair(
  lockMinutes: number,
  logoutMinutes: number,
): IdleTimeoutFieldError | null {
  if (
    !Number.isInteger(lockMinutes) ||
    lockMinutes < IDLE_LOCK_MINUTES_MIN ||
    lockMinutes > IDLE_LOCK_MINUTES_MAX
  ) {
    return 'lockRange';
  }
  if (
    !Number.isInteger(logoutMinutes) ||
    logoutMinutes < IDLE_LOGOUT_MINUTES_MIN ||
    logoutMinutes > IDLE_LOGOUT_MINUTES_MAX
  ) {
    return 'logoutRange';
  }
  if (logoutMinutes <= lockMinutes) {
    return 'logoutMustExceedLock';
  }
  return null;
}

/** Save-time check: skip when the user cannot edit; treat a cleared field as out of range. */
export function idleTimeoutSaveError(
  canEdit: boolean,
  lockMinutes: number,
  logoutMinutes: number,
): IdleTimeoutFieldError | null {
  if (!canEdit) return null;
  if (Number.isNaN(lockMinutes)) return 'lockRange';
  if (Number.isNaN(logoutMinutes)) return 'logoutRange';
  return validateIdleTimeoutPair(lockMinutes, logoutMinutes);
}
